(function () {
    'use strict';

    var module = angular.module('app');

    module.constant("authenticationEvents", {
        loginSuccess: "login-success",
        logoutSuccess: "logout-success"
    });

    module.factory('authService', [
        "$http", "$rootScope", "authenticationTokenService", "$q", "authenticationEvents", "bus",
        function($http, $rootScope, authenticationTokenService, $q, authenticationEvents, bus) {

            var logout = function() {
                authenticationTokenService.setAuthToken(null);
                bus.publish(authenticationEvents.logoutSuccess);
            };
                
            var login = function (username, password) {
                var deferred = $q.defer();

                var url = "/api/account/login";
                var request = {
                    username: username,
                    password: password
                };

                $http.post(url, request)
                    .success(function(response) {
                        authenticationTokenService.setAuthToken(response);
                        bus.publish(authenticationEvents.loginSuccess);
                        deferred.resolve();
                    })
                    .error(function(data, status) {
                        // we only advertise an actual authentication failure if we saw a 401
                        if (status === 401) {
                            logout();
                        }
                        var reason;
                        switch (status) {
                        case 0:
                            reason = "Request timed out. Please try again in a minute.";
                            break;
                        case 401:
                            reason = "Your username or password was incorrect.";
                            break;
                        default:
                            reason = "Something went wrong. Please try again in a minute.";
                        }

                        deferred.reject(reason);
                    });

                return deferred.promise;
            };

            return {
                login: login,
                logout: logout
            };
        }
    ]);
}());